import { useEffect } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { getMachines, getReportForAdmin } from "../../services/services";
import { useState } from "react";

const ViewMachineLogs = () => {

    const [logs, setLogs] = useState([]);

    useEffect(() => {
        getReportForAdmin((response) => {
            // console.log(response.data)
            setLogs(response.data)
        })
    }, [])

    return(
        <Row>
			<Col>
				{logs.length > 0 ? 
					<Table>
						<thead>
							<tr>
								<th>Client Name</th>
								<th>Machine Name</th>
								<th>Machine In</th>
								<th>Machine Out</th>
								<th>Machine Total</th>
							</tr>
						</thead>
						<tbody>
							{logs.map(log => {
								return (
									<tr>
										<td>{log.client_name}</td>
										<td>{log.machine_name}</td>
										<td>{log.machine_in}</td>
										<td>{log.machine_out}</td>
										<td>{log.machine_total}</td>
									</tr>
								)
							})}
						</tbody>
					</Table>
					:
					<></>
				}
			</Col>
		</Row>
    )
}

export default ViewMachineLogs;